import { Role as RestRole } from "../rest-model/Role";
import { Role } from "../domain/Role";
import { ROLE_DISPLAYNAME_PROPERTY_NAME, INSTANCE_ROLE_PROPERTY_NAME } from "../constants/property-constants";
import { isTruthy } from "../lib/utils";

export class RoleAdapter {
    public adaptToDomain(restRole: RestRole): Role {
        const {
            id,
            name,
            created,
            description,
            productId,
            roleType,
            targetIds,
            attributes,
            modified,
            isActive,
            properties
        } = restRole;

        const systemGeneratedRole = properties?.find((p) => p.name === "SystemGenerated")?.value;
        const isInstanceRole = properties?.find((p) => p.name === INSTANCE_ROLE_PROPERTY_NAME)?.value === "true";
        const displayName = properties?.find((p) => p.name === ROLE_DISPLAYNAME_PROPERTY_NAME)?.value || name;

        return new Role({
            id,
            name,
            displayName,
            description,
            productId,
            roleType,
            targetIds,
            isActive,
            isInstanceRole,
            attributes: (attributes || []).map((attribute) => {
                return {
                    id: attribute.id,
                    key: attribute.key,
                    values: attribute.values,
                    path: attribute.path,
                    scopes: attribute.scopes || [],
                    description: attribute.description
                };
            }),
            modified: new Date(modified),
            created: new Date(created),
            isSystemGeneratedRole: isTruthy({ value: systemGeneratedRole })
        });
    }
}
